module.exports = __webpack_public_path__ + "img/5Eagles.31282d8d.svg";